<template>
  <div>
    <v-dialog v-model="notInterested.showPopup" width="500" persistent>
      <v-card>
        <v-card-title>
          <div class="headline">Quelle est la cause de l'abandon ?</div>
        </v-card-title>
        <v-card-text>
          <v-select
            :items="notInterested.causes"
            v-model="notInterested.choice"
            label="Raison..."
          />
          <v-textarea
            v-model="notInterested.reason"
            v-if="notInterested.choice === 'other'"
            label="Expliquez les raisons de l'abandon"
          />
        </v-card-text>
        <v-divider />
        <v-card-actions>
          <v-btn
            color="primary"
            flat
            :disabled="
              !notInterested.choice ||
                (notInterested.choice === 'other' && !notInterested.reason)
            "
            @click="onNotInterestedChoicePicked"
          >
            OK
          </v-btn>
          <v-btn flat @click="cancelNotInterested">Annuler</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-layout row wrap class="mt-2">
      <v-flex xs12 lg6>
        <v-layout row wrap>
          <v-flex>
            <FormLine
              :item="{
                items: progresses,
                value: () => prospect.currentProgress,
                as: 'select',
                name: 'progress',
                label: 'Colonne',
                update: onProgressUpdate
              }"
              :edit-mode="editMode && canChangeColumn"
            />
          </v-flex>
          <v-flex grow>
            <v-checkbox
              class="mt-1 mr-2 justify-end"
              label="Abandonné"
              :input-value="isNotInterested"
              @click.prevent="onNotInterestedChange"
              :tooltip="notInterestedTooltip"
            />
          </v-flex>
        </v-layout>
      </v-flex>
      <v-flex xs12 lg6>
        <FormLine
          :item="{
            name: 'demoDate',
            as: 'date',
            label: 'Date de rdv pour la démo',
            validation: validationRules.demoDate
          }"
          :class="{ invalid: !checkAttribute('demoDate') }"
          v-model="prospect"
          :edit-mode="editMode"
        />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex lg6 xs12>
        <h3 class="ml-3">Informations du prospect</h3>
        <template v-for="item in computedFields.infos">
          <FormLine
            v-if="item.show ? item.show() : true"
            :item="item"
            v-model="prospect"
            :key="item.name"
            :edit-mode="editMode"
          ></FormLine>
          <v-divider :key="`${item.name}-divider`" />
        </template>
        <h3 class="ml-3">Potentiel annuel collaborateur en mobilité</h3>
        <template v-for="item in computedFields.potential">
          <FormLine
            :item="item"
            v-model="prospect"
            :key="item.name.join('_')"
            :edit-mode="editMode"
          ></FormLine>
          <v-divider :key="`${item.name.join('_')}-divider`" />
        </template>
        <h3 class="ml-3">Contact</h3>
        <template v-for="item in computedFields.contact">
          <FormLine
            :item="item"
            v-model="prospect"
            :key="item.name"
            :edit-mode="editMode"
          ></FormLine>
          <v-divider :key="`${item.name}-divider`" />
        </template>
      </v-flex>
      <v-flex xs12 lg6>
        <h3 class="mb-3">
          Modalité du partenariat, historique et suivi des relations, calendrier
          des échanges
        </h3>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title
              :class="{ invalid: !checkAttribute('actionsDone') }"
              >Actions réalisées :</v-list-tile-title
            >
            <v-textarea
              v-model="prospect.actionsDone"
              style="width: 100%"
              v-validate="validationRules.actionsDone"
              data-vv-name="actionsDone"
              :error-messages="errors.collect('actionsDone')"
            />
          </v-list-tile-content>
        </v-list-tile>
        <div class="general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>
              Modalité du partenariat, la communication et son entretien dans le
              temps
            </li>
          </ul>
        </div>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title
              :class="{ invalid: !checkAttribute('actionsToDo') }"
              >Prochaines actions :</v-list-tile-title
            >
            <v-textarea
              v-model="prospect.actionsToDo"
              style="width: 100%"
              v-validate="validationRules.actionsToDo"
              data-vv-name="actionsToDo"
              :error-messages="errors.collect('actionsToDo')"
            />
          </v-list-tile-content>
        </v-list-tile>
        <h3 class="mb-3">Quelques mots sur ...</h3>
        <div class="general-hints">
          <ul>
            <li>
              Objectif : créer le climat de confiance et identifier les
              leviers/axes d'impact pour démontrer que Home in love est la
              solution efficace pour l'intégration de leur salarié en mobilité
            </li>
          </ul>
        </div>
        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title
              :class="{ invalid: !checkAttribute('aboutStructure') }"
              >La structure (entreprise, école...)</v-list-tile-title
            >
            <v-textarea
              v-model="prospect.aboutStructure"
              style="width: 100%"
              v-validate="validationRules.aboutStructure"
              data-vv-name="aboutStructure"
              :error-messages="errors.collect('aboutStructure')"
            />
          </v-list-tile-content>
        </v-list-tile>
        <div class="general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>
              Sa mission, ses métiers, son organisation, les localisations, mois
              de forte activité
            </li>
          </ul>
        </div>

        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title
              :class="{ invalid: !checkAttribute('aboutContacts') }"
              >Les différents interlocuteurs clés</v-list-tile-title
            >
            <v-textarea
              v-model="prospect.aboutContacts"
              style="width: 100%"
              v-validate="validationRules.aboutContacts"
              data-vv-name="aboutContacts"
              :error-messages="errors.collect('aboutContacts')"
            />
          </v-list-tile-content>
        </v-list-tile>
        <div class="general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>
              Apprendre à le connaitre personnellement, son parcours, ses
              motivations, ses points de douleurs
            </li>
          </ul>
        </div>

        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title
              :class="{ invalid: !checkAttribute('aboutProcess') }"
              >Le processus de recrutement pour les
              alternants/cdd/cdi/mutation</v-list-tile-title
            >
            <v-textarea
              v-model="prospect.aboutProcess"
              style="width: 100%"
              v-validate="validationRules.aboutProcess"
              data-vv-name="aboutProcess"
              :error-messages="errors.collect('aboutProcess')"
            />
          </v-list-tile-content>
        </v-list-tile>
        <div class="general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>
              Différentes étapes du recrutement, points de difficulté et marque
              employeur
            </li>
          </ul>
        </div>

        <v-list-tile class="no-height">
          <v-list-tile-content class="no-height">
            <v-list-tile-title
              :class="{ invalid: !checkAttribute('aboutHousing') }"
              >La problématique au logement pour vos salariés</v-list-tile-title
            >
            <v-textarea
              v-model="prospect.aboutHousing"
              style="width: 100%"
              v-validate="validationRules.aboutHousing"
              data-vv-name="aboutHousing"
              :error-messages="errors.collect('aboutHousing')"
            />
          </v-list-tile-content>
        </v-list-tile>
        <div class="general-hints">
          <h4>Fil conducteur</h4>
          <ul>
            <li>
              Offrez vous les aides au logement à tous vos salariés, avons-nous
              reloger
            </li>
          </ul>
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-if="showStats">
      <v-flex lg12 xs12>
        <h3 class="my-3">Statistiques</h3>
        <Stats :chart-data="statsData" :chart-options="statsOptions" />
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
import Stats from "@/components/prospect/Stats.vue";
import * as _ from "lodash";
import {
  getInfoFields,
  getValidationRulesFromProgress,
  notInterestedCauses
} from "@/data/prospectData";
import { checkFormLine } from "@/utils";
import FormLine from "../commons/FormLine.vue";
import { ALL_PROSPECTS_COLUMNS } from "@/data/DefaultSettings";
import { mapGetters, mapState } from "vuex";

export default {
  props: ["editMode"],
  components: {
    FormLine,
    Stats
  },
  inject: ["$validator"],
  data() {
    return {
      notInterested: {
        causes: notInterestedCauses,
        showPopup: false,
        choice: null,
        reason: null
      }
    };
  },
  methods: {
    onProgressUpdate(step) {
      this.prospect.currentProgress = step;
      this.$forceUpdate();
    },
    onNotInterestedChange(value) {
      if (value) {
        this.notInterested.showPopup = true;
      } else {
        this.prospect.notInterested = null;
      }
    },
    onNotInterestedChoicePicked() {
      this.prospect.notInterested =
        this.notInterested.choice === "other"
          ? this.notInterested.reason
          : this.notInterested.choice;
      this.notInterested.showPopup = false;
    },
    cancelNotInterested() {
      this.notInterested.showPopup = false;
    },
    checkAttribute(attribute) {
      return checkFormLine(
        this.validationRules[attribute],
        _.get(this.prospect, attribute),
        this.prospect
      );
    }
  },
  computed: {
    ...mapState("prospects", {
      prospect: state => state.current
    }),
    ...mapGetters("user", ["isSuperAdmin"]),

    computedFields() {
      return getInfoFields(this.prospect);
    },

    validationRules() {
      return getValidationRulesFromProgress(this.prospect.currentProgress);
    },

    isNotInterested() {
      return Boolean(this.prospect.notInterested);
    },

    notInterestedTooltip() {
      if (!this.prospect.notInterested) {
        return;
      }

      const cause = notInterestedCauses.find(
        c => c.value === this.prospect.notInterested
      );
      if (cause) {
        return cause.text;
      }

      return this.prospect.notInterested;
    },

    canChangeColumn() {
      return this.editMode && this.isSuperAdmin;
    },

    progresses() {
      const columns = ALL_PROSPECTS_COLUMNS.filter(
        ({ isAgregate }) => !isAgregate
      ).map((c, i) => ({ ...c, text: `[${i < 10 ? `0${i}` : i}] ${c.text}` }));
      if (this.isSuperAdmin) {
        return columns;
      } else {
        return columns.filter(({ superAdminOnly }) => !superAdminOnly);
      }
    },

    showStats() {
      return this.statsData.datasets.some(ds => ds.data.length);
    },

    statsData() {
      return {
        datasets: [
          {
            label: "Clics",
            backgroundColor: "rgba(255,0,0,0.22)",
            pointBackgroundColor: "#FF0000",
            fill: true,
            data: this.prospect.clicks
              ? _.sortBy(
                  Object.keys(this.prospect.clicks).flatMap(year =>
                    Object.keys(this.prospect.clicks[year]).map(month => ({
                      x: `${year}-${month}`,
                      y: this.prospect.clicks[year][month]
                    }))
                  ),
                  "x"
                )
              : []
          },
          {
            label: "Dossiers clients créés",
            backgroundColor: "rgba(3,106,180,0.32)",
            pointBackgroundColor: "#0000FF",
            fill: true,
            data: _.sortBy(
              this.prospect.leaseStats.map(stat => ({
                x: `${stat.year}-${_.padStart(stat.month, 2, "0")}`,
                y: stat.created
              })),
              "x"
            )
          },
          {
            label: "Dossiers clients relogés",
            backgroundColor: "rgba(3,180,44,0.32)",
            pointBackgroundColor: "#24ea53",
            fill: true,
            data: _.sortBy(
              this.prospect.leaseStats.map(stat => ({
                x: `${stat.year}-${_.padStart(stat.month, 2, "0")}`,
                y: stat.leaseFetched
              })),
              "x"
            )
          }
        ]
      };
    },

    statsOptions() {
      return {
        maintainAspectRatio: false,
        scales: {
          x: {
            type: "time",
            time: {
              parser: "YYYY-MM",
              displayFormats: {
                month: "MM/YYYY"
              },
              unit: "month"
            }
          },
          y: {
            type: "linear",
            beginAtZero: true,
            grace: "15%",
            ticks: { precision: 0 }
          }
        },
        plugins: {
          datalabels: {
            color: "rgb(117,117,117)",
            anchor: "end",
            align: "top",
            display(context) {
              return context.dataset.data[context.dataIndex] !== 0;
            },
            formatter(value) {
              return value.y;
            }
          }
        }
      };
    }
  }
};
</script>

<style scoped>
.no-clamp {
  -webkit-line-clamp: 1000 !important;
}

.fsz {
  font-size: 12px !important;
}

.general-hints {
  color: #555;
  margin-left: 30px;
  margin-bottom: 24px;
}

.invalid {
  color: darkorange;
  font-weight: bold;
}
</style>
